import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useSelectBrand, { Brand } from '../../hooks/useSelectBrand';
import { BrandsList } from '../BrandsList';

export default function AppLayout() {
  const navigate = useNavigate();
  let { pathname } = useLocation();
  const { brand, setBrand } = useSelectBrand();

  let params = useParams();

  useEffect(() => {
    const brandParam = (params?.brand?.toLocaleUpperCase() as Brand) || '';

    if (brandParam in Brand) {
      setBrand(brandParam);
    } else {
      setBrand(undefined);
      navigate('/');
    }
  }, [brand, navigate, params?.brand, pathname, setBrand]);

  return !params?.brand ? <BrandsList setBrand={setBrand} /> : <Outlet />;
}
